import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { candidateReviewApi } from '../candidateReviewApi';
import type { GetCandidateReviewsRequest } from '../types';

export const useGetCandidateReviews = (
  params: GetCandidateReviewsRequest,
  enabled = true
) => {
  return useQuery({
    queryKey: [QueryKey.GET_CANDIDATE_REVIEWS, params],
    queryFn: () => candidateReviewApi.getCandidateReviews(params),
    enabled,
    retry: false,
  });
};
